import styled from "styled-components";
import { Button } from "@material-ui/core";

export const STPinButton = styled(Button)`
  && {
    width: 60px;
    height: 60px;
  }
`;
